import * as Types from '../../../__generated__/schema';

import { DataSchemaFull } from '../../graphql/fragments/DataSchemaFull.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSchemaDetailsVariables = Types.Exact<{
  input: Types.GetSchemaInput;
}>;

export type GetSchemaDetails = {
  getSchema: {
    error?: Types.Maybe<Pick<Types.Error, 'code' | 'message'>>;
    schema?: Types.Maybe<DataSchemaFull>;
  };
};

export const GetSchemaDetailsDocument = gql`
  query GetSchemaDetails($input: GetSchemaInput!) {
    getSchema(input: $input) {
      error {
        code
        message
      }
      schema {
        ...DataSchemaFull
      }
    }
  }
  ${DataSchemaFull}
`;

/**
 * __useGetSchemaDetails__
 *
 * To run a query within a React component, call `useGetSchemaDetails` and pass it any options that fit your needs.
 * When your component renders, `useGetSchemaDetails` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSchemaDetails({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSchemaDetails(
  baseOptions: Apollo.QueryHookOptions<GetSchemaDetails, GetSchemaDetailsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSchemaDetails, GetSchemaDetailsVariables>(
    GetSchemaDetailsDocument,
    options,
  );
}
export function useGetSchemaDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSchemaDetails, GetSchemaDetailsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSchemaDetails, GetSchemaDetailsVariables>(
    GetSchemaDetailsDocument,
    options,
  );
}
export function useGetSchemaDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSchemaDetails, GetSchemaDetailsVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSchemaDetails, GetSchemaDetailsVariables>(
    GetSchemaDetailsDocument,
    options,
  );
}
export type GetSchemaDetailsHookResult = ReturnType<typeof useGetSchemaDetails>;
export type GetSchemaDetailsLazyQueryHookResult = ReturnType<typeof useGetSchemaDetailsLazyQuery>;
export type GetSchemaDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetSchemaDetailsSuspenseQuery
>;
export type GetSchemaDetailsQueryResult = Apollo.QueryResult<
  GetSchemaDetails,
  GetSchemaDetailsVariables
>;
export function mockGetSchemaDetails({
  data,
  variables,
  errors,
}: {
  data: GetSchemaDetails;
  variables?: GetSchemaDetailsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetSchemaDetailsDocument, variables },
    result: { data, errors },
  };
}
